import dashboardSensorsQuery from '../../../Dashboard/Content/SensorsQuery/lib/query'

export default ({
  query,
}) => ([
  { query },
  { query: dashboardSensorsQuery, variables: { filters: [] } },
])
